import { useMutation } from "@tanstack/react-query";
import { uploadFile } from "./requests";

export const useUploadFileMutation = (onSuccess: (response: any) => void, onError: (error: any) => void) => {
  return useMutation({
    mutationKey: ['files', 'upload'],
    mutationFn: (payload: { file: File, name?: string, owner?: { id: string; resourceType: string } }) => 
      uploadFile(payload.file, payload.name, payload.owner),
    onSuccess,
    onError
  });
};